function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20soft%20warm%20golden%20abstract%20background%20with%20gentle%20flowing%20curves%2C%20luxurious%20texture%2C%20minimalist%20design%2C%20warm%20cream%20and%20soft%20amber%20tones%2C%20premium%20wellness%20brand%20aesthetic%2C%20subtle%20gradient%2C%20no%20text&width=1800&height=900&seq=xfb-hero-bg&orientation=landscape"
          alt="性福寶官方網站背景"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-5 leading-tight">
          讓每一刻更幸福
        </h1>
        <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          性福寶，專為追求高品質親密生活的人群研發，採用天然精華配方，
          幫助提升活力與自信，讓您的每一刻都充滿幸福感。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#cta"
            className="bg-primary-500 text-background-50 px-8 py-3.5 rounded-md text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer w-full sm:w-auto"
          >
            立即了解
          </a>
          <a
            href="#features"
            className="border border-background-200/60 text-background-100 px-8 py-3.5 rounded-md text-base font-medium whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer w-full sm:w-auto"
          >
            了解更多
          </a>
        </div>

        <div className="flex items-center justify-center gap-8 mt-14">
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">50,000+</p>
            <p className="text-xs md:text-sm text-background-300 mt-1">滿意用戶</p>
          </div>
          <div className="w-px h-10 bg-background-200/30"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">98%</p>
            <p className="text-xs md:text-sm text-background-300 mt-1">好評率</p>
          </div>
          <div className="w-px h-10 bg-background-200/30"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">10年</p>
            <p className="text-xs md:text-sm text-background-300 mt-1">研發積累</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;